import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { mustLeavePreviewRoute } from "./betaPreview";

/**
 * Keeps the user off a preview-only page (the Training page) while Beta Preview is off (ACOP-163).
 *
 * The switch always starts OFF and is never saved, so one rule covers all three ways onto such a page
 * with it off: switching it OFF while on the page, a reload, and a deep link. Each lands on Home.
 * `replace`, so Back does not return to a page that would only bounce again.
 *
 * `showChat` is Main's "signed in and ready" flag: until it is true the sign-in screen is showing,
 * and a signed-out visitor must get that rather than being moved around behind it.
 *
 * `previewOn` is the RESOLVED switch (utils/betaPreview.ts isBetaPreviewOn — employee role AND the
 * flag), so a caller who is not an employee is never kept on the page by a stale flag.
 */
export function usePreviewRouteGuard(showChat: boolean, previewOn: boolean): void {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (showChat && mustLeavePreviewRoute(pathname, previewOn)) {
      navigate("/home", { replace: true });
    }
  }, [showChat, pathname, previewOn, navigate]);
}
